import React from 'react'
import logo from "../images/logo_inverse.svg"
import posed from 'react-pose';

const ToAppear = posed.div({
  open: { opacity: 1, y: 0, transition: ({ after }) => ({ delay: after }) },
  closed: { opacity: 0, y: 20 }
});

export default () =>
  <ToAppear initialPose="closed" pose="open" after={200}>
    <img src={logo} alt="logo" width="165" />
  </ToAppear>
